__turbopack_context__.v({
  "container": "fbk3Ya_container",
  "icon": "fbk3Ya_icon",
  "text": "fbk3Ya_text",
});
